import Bugsnag from "@bugsnag/js"
import BugsnagReact from "@bugsnag/plugin-react"
import React from "react"

const apiKey = process.env.GATSBY_BUGSNAG

if (apiKey) {
  Bugsnag.start({
    apiKey,
    releaseStage: process.env.NODE_ENV,
    enabledReleaseStages: ["production"],
    appVersion: process.env.GATSBY_RELEASE,
    metadata: {
      deployDate: process.env.GATSBY_DEPLOY_DATE,
    },
    plugins: [new BugsnagReact(React)],
  })
}

export const ErrorBoundary = apiKey ? Bugsnag.getPlugin("react")?.createErrorBoundary() : null

export const handleError = (error: any) => {
  console.error(error) // eslint-disable-line no-console
  if (apiKey) {
    Bugsnag.notify(error)
  }
}
